import React, { useEffect, useState, useContext } from 'react';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import HeaderComponent from './HeaderComponent';
import { apiService, setupInterceptors } from '../services/apiService';
import { AuthContext } from '../context/AuthContext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import '../styles/PanelVentas.css';
import { confirmDialog } from 'primereact/confirmdialog';
import ClientePresupuesto from './ClientePresupuesto'
import FormNuevoCliente from './FormNuevoCliente';
import ModalContainer from './ModalContainer';

const Presupuesto = ({ toast, setLoading, setConfirmDialog }) => {
    const { logoutUser } = useContext(AuthContext);
    const [productos, setProductos] = useState([]);
    const [selectedProducto, setSelectedProducto] = useState(null);
    const [carrito, setCarrito] = useState([]);
    const [ clientes, setClientes ] = useState([])
    const [ clienteSeleccionado, setClienteSeleccionado ] = useState(null);
    const [showModalCliente, setShowModalCliente] = useState(false);

    const [ metodosPago, setMetodosPago ] = useState([]);
    const [ selectedMetodoPago, setSelectedMetodoPago ] = useState(null);

    const openModalCliente = () => setShowModalCliente(true);
    const hideModalCliente = () => setShowModalCliente(false);

    useEffect(() => {
        console.log(clienteSeleccionado);
    }, [clienteSeleccionado])

    const getClientes = async () => {
        try {
            const response = await apiService.fetchData('clientes/');
            const clientesList = response.data.map(cliente => ({
                id: cliente.id,
                nombre: cliente.nombre,
            }));
            setClientes(clientesList); 
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const postClientes = async (data) => {
        try {
            const response = await apiService.postData('clientes/', data);
            const nuevoCliente = {
                id: response.data.id,
                nombre: response.data.nombre,
            };
            
            // Actualiza el estado de las categorías agregando la nueva categoría
            setClientes(prevClientes => [...prevClientes, nuevoCliente]);

            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Producto creado exitosamente!', life: 2000});

            
            // Opcional: cierra el modal tras agregar la nueva categoría
            hideModalCliente();

        } catch (error) {
            toast.current.show({severity:'error', summary: 'Error', detail:{error}, life: 3000});
            console.error('Error al realizar la creacion:', error.response ? error.response.data : error.message);
        }
    };


    useEffect(() => {
        setupInterceptors(logoutUser);
        getProductos();
        getMetodosPago();
        getClientes();
    }, []);

    const getProductos = async () => {
        try {
            const response = await apiService.fetchData('productos/');
            // const productosList = response.data.map(producto => ({
            //     id: producto.id,
            //     categoria_nombre: producto.categoria_nombre,
            //     codigo: producto.codigo,
            //     nombre: producto.nombre,
            //     fabricante: producto.fabricante,
            //     cantidad_disponible: producto.cantidad_disponible,
            //     precio_producto: producto.precio_producto,
            //     codigo_producto: producto.codigo_producto,
            //     costo_producto: producto.ultimo_costo_producto,
            //     proveedor_nombre: producto.proveedor_nombre
            // }));
            setProductos(response.data);
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const getMetodosPago = async () => {
        try {
            const response = await apiService.fetchData('metodos_pago/');
            const metodosPagoList = response.data.map(metodo_pago => ({
                id: metodo_pago.id,
                interes: metodo_pago.interes,
                nombre_interes: metodo_pago.nombre_interes
            }));
            setMetodosPago(metodosPagoList);
        } catch (error) {
            console.error('Error al obtener datos:', error.response ? error.response.data : error.message);
        }
    };

    const agregarAlCarrito = () => {
        if (selectedProducto) {
            console.log(selectedProducto);
            const productoEnCarrito = carrito.find(p => p.id === selectedProducto.id);
            if (!productoEnCarrito) {
                setCarrito([...carrito, { ...selectedProducto,
                    nombre: `${selectedProducto.nombre} - ${selectedProducto.proveedor_nombre}`, // Concatenar los valores
                    cantidad: 0, descuento: 0, total: 0 }]);
            }
            else{
                toast.current.show({ severity: 'warn', summary: 'Advertencia', detail: 'El articulo ya se encuentra en el carrito!', life: 3000 });
            }

            // Limpiar el Dropdown y el filtro
            setSelectedProducto(null);
        }
    };



    // Validación de solo números en cantidad, precio y descuento
    const handleNumericInput = (value) => {
        const numericValue = value.replace(/[^0-9.]/g, '');
        return numericValue;
    };

    const actualizarDescuento = (productoId, descuento) => {
        const numericDescuento = handleNumericInput(descuento);
        const nuevoCarrito = carrito.map(producto => {
            if (producto.id === productoId) {
                const descuentoDecimal = numericDescuento / 100;
                const totalConDescuento = producto.precio_producto * producto.cantidad - (producto.precio_producto * producto.cantidad * descuentoDecimal);
                return { ...producto, descuento: numericDescuento, total: totalConDescuento.toFixed(2) };
            }
            return producto;
        });
        setCarrito(nuevoCarrito);
    };

    const actualizarCantidad = (productoId, cantidad, cantidadDisponible) => {
        const numericCantidad = handleNumericInput(cantidad);
    
        const nuevoCarrito = carrito.map(producto => {
            if (producto.id === productoId) {
                const totalConCantidad = (producto.precio_producto * numericCantidad) - (producto.precio_producto * numericCantidad * (producto.descuento / 100));
                return { ...producto, cantidad: numericCantidad, total: totalConCantidad.toFixed(2) };
            }
            return producto;
        });
        setCarrito(nuevoCarrito);
    };

    const actualizarPrecio = (productoId, precio) => {
        const numericPrecio = handleNumericInput(precio);
        const nuevoCarrito = carrito.map(producto => {
            if (producto.id === productoId) {
                const totalConPrecio = (numericPrecio * producto.cantidad) - (numericPrecio * producto.cantidad * (producto.descuento / 100));
                return { ...producto, precio_producto: numericPrecio, total: totalConPrecio.toFixed(2) };
            }
            return producto;
        });
        setCarrito(nuevoCarrito);
    };

    const removerDelCarrito = (productoId) => {
        const nuevoCarrito = carrito.filter(producto => producto.id !== productoId);
        setCarrito(nuevoCarrito);
    };

    const calcularImporteTotal = () => {
        return carrito.reduce((total, producto) => total + parseFloat(producto.total), 0).toFixed(2);
    };
    

    const validarCamposCarrito = () => {
        for (const producto of carrito) {
            console.log(producto)
            if (!producto.cantidad || !producto.precio_producto  || producto.descuento === null || producto.cantidad === 0 || producto.cantidad === "0" ) {
                return false; // Hay al menos un campo vacío
            }
        }
        return true; // Todos los campos están llenos
    };

    const confirmarVenta = () => {
        if(!clienteSeleccionado){
            toast.current.show({ severity: 'warn', summary: 'Advertencia', detail: 'Debe Seleccionar un Cliente para continuar!', life: 3000 });
            return;
        }

        if (carrito.length > 0) {
            if (!validarCamposCarrito()) {
                toast.current.show({ severity: 'warn', summary: 'Advertencia', detail: 'Todos los campos deben estar completos!', life: 3000 });
                return; // Salir de la función si hay campos vacíos
            }

            confirmDialog({
                message: '¿Está seguro de que desea confirmar la compra?',
                header: 'Confirmación',
                icon: 'pi pi-info-circle',
                acceptLabel: "Confirmar",
                accept: () => {
                    const data = {
                        "carrito": carrito,
                        "metodo_pago": selectedMetodoPago,
                        "importe_total": calcularImporteTotal(),
                        "cliente": clienteSeleccionado
                    }
                    postVenta(data)
                },
                reject: () => {
                    console.log('Confirmación rechazada');
                }
            });
        } else {
            toast.current.show({ severity: 'warn', summary: 'Advertencia', detail: 'Debe agregar productos al carrito!', life: 3000 });
        }
    };

    const postVenta = async (data) => {
        try {
            setLoading(true);
            const response = await apiService.postData('presupuestos/', data);

            setLoading(false);
            setConfirmDialog(true);

            toast.current.show({severity:'success', summary: 'Solicitud Exitosa', detail:'Presupuesto creado exitosamente!', life: 2000});

            setCarrito([])

        } catch (error) {
            setLoading(false);
            console.log(error);
            toast.current.show({severity:'error', summary: 'Error', detail: error.response.data.msg ? error.response.data.msg : error.message, life: 3000});
            console.error('Error al realizar la creacion:', error.response.msg ? error.response.data.msg: error.message);
        }
    };

    return (
        <>
            <HeaderComponent title={"Presupuesto"} />
            <div className='col-12 ml-6' style={{ minWidth: "95%", maxWidth: "95%" }}>

            <div style={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                flexDirection: "column", 
                gap: "10px"
            }}>
                <ClientePresupuesto
                    clientes={clientes}
                    clienteSeleccionado={clienteSeleccionado}
                    setClienteSeleccionado={setClienteSeleccionado}
                    openModalCliente={openModalCliente}
                    />
                <div className='ml-2' style={{ fontSize: "20px" }}>
                    <p>Seleccione Productos para el Carrito</p>
                </div>

                {/* Dropdown con filtro para seleccionar el producto */}
                <Dropdown
                    value={selectedProducto}
                    options={productos}
                    onChange={(e) => setSelectedProducto(e.value)}
                    optionLabel="codigo_producto"
                    filter
                    showClear
                    placeholder="Selecciona un producto"
                    style={{ width: '20%' }}
                    itemTemplate={(option) => (
                        <div>
                            {option.codigo} - <strong>{option.nombre}</strong> - {option.proveedor_nombre}
                        </div>
                    )}
                    valueTemplate={(option) => 
                        option ? (
                            <div>
                                {option.codigo} - <strong>{option.nombre}</strong> - {option.proveedor_nombre}
                            </div>
                        ) : (
                            <span>Selecciona un producto</span>
                        )
                    }
                />
                <Button 
                    label="Agregar" 
                    icon="pi pi-shopping-cart" 
                    onClick={agregarAlCarrito} 
                    disabled={!selectedProducto} 
                />
            </div>


                {/* Carrito de Compras */}
                <div className='carrito'>
                    <h3>Carrito de Compras</h3>
                    <DataTable value={carrito} responsiveLayout="scroll">
                        <Column style={{textAlign:"center" }} className='width-columns' headerClassName='header-table-style' alignHeader={"center"} field="codigo" header="Código" />
                        <Column style={{textAlign:"center" }} headerClassName='header-table-style' alignHeader={"center"} field="nombre" header="Nombre" />
                        <Column style={{textAlign:"center" }} className='width-columns' headerClassName='header-table-style' alignHeader={"center"}
                            header="Cantidad"
                            body={(rowData) => (
                                <InputText
                                    value={rowData.cantidad}
                                    onChange={(e) => actualizarCantidad(rowData.id, e.target.value, rowData.cantidad_disponible)}
                                    className='width-columns'
                                    type="number"
                                    style={{ textAlign:"center" }}
                                    pattern="\d*"
                                />
                            )}
                        />
                        <Column style={{textAlign:"center" }} className='width-columns' headerClassName='header-table-style' alignHeader={"center"}
                            header="Precio Unit."
                            body={(rowData) => (
                                <InputText
                                    value={rowData.precio_producto}
                                    onChange={(e) => actualizarPrecio(rowData.id, e.target.value)}
                                    type="text"
                                    className='width-columns'
                                    style={{ textAlign:"center" }}
                                    pattern="\d*"
                                />
                            )}
                        />
                        <Column style={{textAlign:"center" }} className='width-columns' headerClassName='header-table-style' alignHeader={"center"}
                            header="Descuento (%)"
                            body={(rowData) => (
                                <InputText
                                    value={rowData.descuento}
                                    onChange={(e) => actualizarDescuento(rowData.id, e.target.value)}
                                    type="text"
                                    className='width-columns'
                                    style={{ textAlign:"center" }}
                                    pattern="\d*"
                                />
                            )}
                        />
                        <Column style={{textAlign:"center" }} className='width-columns' headerClassName='header-table-style' alignHeader={"center"} field="costo_producto" header="Ult. Costo Unit." />
                        <Column style={{textAlign:"center" }} className='width-columns' headerClassName='header-table-style' alignHeader={"center"} field="total" header="Total" />
                        <Column style={{textAlign:"center" }} className='width-columns' headerClassName='header-table-style' alignHeader={"center"}
                            body={(rowData) => (
                                <Button  icon="pi pi-trash" className="p-button-danger" onClick={() => removerDelCarrito(rowData.id)} />
                            )}
                            header="Acción"
                        />
                    </DataTable>

                    {/* Importe total estilizado */}
                    

                    <div className='importe_total'>
                        <div>Importe Total:</div>
                        <div className="ml-1">$ {calcularImporteTotal()}</div>
                    </div>

                    <div className='flex justify-content-center mt-4 pb-4'>
                        <Button label='Confirmar Venta' size='small' icon='pi pi-cart-plus' severity='warning' onClick={() => confirmarVenta()} />
                    </div>
                </div>
            </div>

            <ModalContainer
                title="Agregar Cliente"
                show={showModalCliente}
                close={hideModalCliente}
                idForm="FormNuevoCliente"
                widthSize="25vw">
                    <FormNuevoCliente postClientes={postClientes} />
            </ModalContainer>
        </>
    );
};

export default Presupuesto;
